@if (!isUrlsDisabled) {
  <div class="container" role="main">
    <div class="HmsContainer">
      @if (isformloaded) {
        <div class="row HmsInsideContainer">
          <div class="col-md-12">
            <p role="heading" aria-level="1">Please make selections from the required fields below. Note that based on the
              selections made, additional form fields may be displayed.
            </p>
          </div>
        </div>
      }
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <form class="userForm" [formGroup]="userFormPart1">
            @if (isformloaded) {
              <div class="col-md-10">
                <app-json-form [controlsData]="userFormDataPart1.controls" [formData]="userFormPart1"
                  (valueChangeEvent)="valueChangeEvent($event)">
                </app-json-form>
              </div>
            }
          </form>
        </div>
        @if (anonymousMessage!='') {
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
            <br />
            <p><span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red"
              class="bi bi-info-circle-fill" viewBox="0 0 16 16">
              <path
                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
              </svg>&nbsp;</span>{{ anonymousMessage }}</p>
              <br />
            </div>
          }
        </div>
        @if (isReferringForm) {
          <div class="row HmsInsideContainer">
            <div class="col-md-12">
              <p role="heading" aria-level="1">{{ referralFormMessageSub }}</p>
            </div>
          </div>
          @if (referralFormType=='2') {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-6">
                <form class="contactForm" [formGroup]="selfReferringPartyFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="selfReferringPartyDataPart1.controls"
                      [formData]="selfReferringPartyFormPart1" (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-6">
                <form class="contactForm" [formGroup]="selfReferringPartyFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="selfReferringPartyDataPart2.controls"
                      [formData]="selfReferringPartyFormPart2" (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="contactForm" [formGroup]="selfReferringPartyFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="selfReferringPartyDataPart3.controls"
                            [formData]="selfReferringPartyFormPart3"
                          (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="contactForm" [formGroup]="selfReferringPartyFormPart4">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="selfReferringPartyDataPart4.controls"
                            [formData]="selfReferringPartyFormPart4"
                          (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (referralFormType=='3') {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-6">
                <form class="contactForm" [formGroup]="thirdPartyReferringPartyFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="thirdPartyReferringPartyDataPart1.controls"
                      [formData]="thirdPartyReferringPartyFormPart1" (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-6">
                <form class="contactForm" [formGroup]="thirdPartyReferringPartyFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="thirdPartyReferringPartyDataPart2.controls"
                      [formData]="thirdPartyReferringPartyFormPart2" (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="contactForm" [formGroup]="thirdPartyReferringPartyFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="thirdPartyReferringPartyDataPart3.controls"
                            [formData]="thirdPartyReferringPartyFormPart3"
                          (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="contactForm" [formGroup]="thirdPartyReferringPartyFormPart4">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="thirdPartyReferringPartyDataPart4.controls"
                            [formData]="thirdPartyReferringPartyFormPart4"
                          (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (referralFormType=='3') {
            <div class="row HmsInsideContainer">
              <div class="col-md-12">
                <p role="heading" aria-level="1">As the individual completing this form, please provide your information below:</p>
              </div>
            </div>
          }
          @if (referralFormType=='3') {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="contactForm" [formGroup]="individualReferringPartyFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="individualReferringPartyDataPart1.controls" [formData]="individualReferringPartyFormPart1"
                      (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="contactForm" [formGroup]="individualReferringPartyFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="individualReferringPartyDataPart2.controls" [formData]="individualReferringPartyFormPart2"
                      (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="contactForm" [formGroup]="individualReferringPartyFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10" style="width: 70% !important;">
                          <app-json-form [controlsData]="individualReferringPartyDataPart3.controls" [formData]="individualReferringPartyFormPart3"
                          (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="contactForm" [formGroup]="individualReferringPartyFormPart4">
                      @if (isformloaded) {
                        <div class="col-md-10" style="width: 70% !important;">
                          <app-json-form [controlsData]="individualReferringPartyDataPart4.controls" [formData]="individualReferringPartyFormPart4"
                          (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
              <br />
            </div>
          }
        }
        @if (isContactForm) {
          <div class="row HmsInsideContainer">
            <div class="col-md-12">
              <p role="heading" aria-level="1">{{ contactFormMessageSub }}</p>
            </div>
            <div class="col-md-12">
              <p role="heading" aria-level="1">{{ contactFormMessageSecondline }}</p>
            </div>
          </div>
        }
        @if (isContactForm) {
          <div class="row HmsInsideContainer">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <form class="contactForm" [formGroup]="contactFormPart1">
                @if (isformloaded) {
                  <div class="col-md-10">
                    <app-json-form [controlsData]="contactFormDataPart1.controls" [formData]="contactFormPart1"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <form class="contactForm" [formGroup]="contactFormPart2">
                @if (isformloaded) {
                  <div class="col-md-10">
                    <app-json-form [controlsData]="contactFormDataPart2.controls" [formData]="contactFormPart2"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <form class="contactForm" [formGroup]="contactFormPart3">
                    @if (isformloaded) {
                      <div class="col-md-10" style="width: 70% !important;">
                        <app-json-form [controlsData]="contactFormDataPart3.controls" [formData]="contactFormPart3"
                        (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                      </div>
                    }
                  </form>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <form class="contactForm" [formGroup]="contactFormPart4">
                    @if (isformloaded) {
                      <div class="col-md-10" style="width: 70% !important;">
                        <app-json-form [controlsData]="contactFormDataPart4.controls" [formData]="contactFormPart4"
                        (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                      </div>
                    }
                  </form>
                </div>
              </div>
            </div>
            <br />
          </div>
        }
        <div class="row HmsInsideContainer">
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
            <form class="userForm" [formGroup]="userFormPart2">
              @if (isformloaded) {
                <div class="col-md-10">
                  <app-json-form [controlsData]="userFormDataPart2.controls" [formData]="userFormPart2"
                    (valueChangeEvent)="valueChangeEvent($event)">
                  </app-json-form>
                </div>
              }
            </form>
          </div>
        </div>
        @if (isInvolvedPartyForm) {
          <div class="row HmsInsideContainer">
            <div class="col-md-12">
              <p role="heading" aria-level="1">Enter any available information regarding the {{ involvedPartyTypeName }}</p>
            </div>
          </div>
          @if (profileMasterTypeKey == 1) {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="providerFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="providerFormDataPart1.controls" [formData]="providerFormPart1"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="providerFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="providerFormDataPart2.controls" [formData]="providerFormPart2"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
              </div>
            </div>
          }
          @if (profileMasterTypeKey == 2) {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="memberFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="memberFormDataPart1.controls" [formData]="memberFormPart1"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="memberFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="memberFormDataPart2.controls" [formData]="memberFormPart2"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <form class="userForm" [formGroup]="memberFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="memberFormDataPart3.controls" [formData]="memberFormPart3"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="userForm" [formGroup]="memberFormPart4">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="memberFormDataPart4.controls" [formData]="memberFormPart4"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (profileMasterTypeKey == 3) {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="noeProviderFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="noeProviderFormDataPart1.controls" [formData]="noeProviderFormPart1"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="noeProviderFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="noeProviderFormDataPart2.controls" [formData]="noeProviderFormPart2"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <form class="userForm" [formGroup]="noeProviderFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="noeProviderFormDataPart3.controls" [formData]="noeProviderFormPart3"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="userForm" [formGroup]="noeProviderFormPart4">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="noeProviderFormDataPart4.controls" [formData]="noeProviderFormPart4"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (profileMasterTypeKey == 4) {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="noeOrgFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="noeOrgFormDataPart1.controls" [formData]="noeOrgFormPart1"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="noeOrgFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="noeOrgFormDataPart2.controls" [formData]="noeOrgFormPart2"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <form class="userForm" [formGroup]="noeOrgFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="noeOrgFormDataPart3.controls" [formData]="noeOrgFormPart3"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="userForm" [formGroup]="noeOrgFormPart4">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="noeOrgFormDataPart4.controls" [formData]="noeOrgFormPart4"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (profileMasterTypeKey == 5) {
            <div class="row HmsInsideContainer">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="noeIndFormPart1">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="noeIndFormDataPart1.controls" [formData]="noeIndFormPart1"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <form class="userForm" [formGroup]="noeIndFormPart2">
                  @if (isformloaded) {
                    <div class="col-md-10">
                      <app-json-form [controlsData]="noeIndFormDataPart2.controls" [formData]="noeIndFormPart2"
                        (valueChangeEvent)="valueChangeEvent($event)">
                      </app-json-form>
                    </div>
                  }
                </form>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                    <form class="userForm" [formGroup]="noeIndFormPart3">
                      @if (isformloaded) {
                        <div class="col-md-10">
                          <app-json-form [controlsData]="noeIndFormDataPart3.controls" [formData]="noeIndFormPart3"
                            (valueChangeEvent)="valueChangeEvent($event)">
                          </app-json-form>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>
            </div>
          }
        }
        @if (isformloaded) {
          <div class="row HmsInsideContainer">
            <p role="heading" aria-level="1">Please enter details regarding this report:</p>
          </div>
        }
        <div class="row HmsInsideContainer">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <form class="userForm" [formGroup]="userFormPart3">
                @if (isformloaded) {
                  <div class="col-md-10" style="width: 85% !important;">
                    <app-json-form [controlsData]="userFormDataPart3.controls" [formData]="userFormPart3"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <form class="userForm" [formGroup]="userFormPart4">
                @if (isformloaded) {
                  <div class="col-md-8" style="width: 65% !important;">
                    <app-json-form [controlsData]="userFormDataPart4.controls" [formData]="userFormPart4"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
              <form class="userForm" [formGroup]="userFormPart5">
                @if (isformloaded) {
                  <div class="col-md-9">
                    <app-json-form [controlsData]="userFormDataPart5.controls" [formData]="userFormPart5"
                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                  </div>
                }
              </form>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <form class="userForm" [formGroup]="userFormPart6">
              @if (isformloaded) {
                <div class="col-md-11">
                  <app-json-form [controlsData]="userFormDataPart6.controls" [formData]="userFormPart6"
                  (valueChangeEvent)="valueChangeEvent($event)" [textAreaRows]="15"></app-json-form>
                </div>
              }
            </form>
          </div>
        </div>
        @if (isQtnsVisible) {
          <div class="row HmsInsideContainer">
            <p role="heading" aria-level="1">Please respond to the questions below and enter any required information.</p>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <form class="questionsForm" [formGroup]="questionsForm">
                @if (isformloaded) {
                  <div class="col-md-10">
                    @if (questionsFormData && questionsFormData.controls && questionsFormData.controls.length > 0) {
                      <app-json-form
                        [controlsData]="questionsFormData.controls" [formData]="questionsForm" [controlWidth]="true"
                        [isQuePage]="true" [customClass]="'controlPadding'"
                      (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                    }
                    @if (isUploadAttatchment) {
                      <app-upload-file></app-upload-file>
                    }
                  </div>
                }
              </form>
            </div>
          </div>
        }
        @if (isformloaded) {
          <div class="row HmsInsideContainer">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              @if (isFormsValid) {
                <div>
                  <app-re-captcha (captchaEvent)="onCaptchaResolved($event)"></app-re-captcha>
                </div>
              }
              <form class="agreementForm" [formGroup]="agreementForm" (ngSubmit)="agreementDetailsSubmit()">
                <div class="row">
                  <div class="col-md-2">
                    <button type="submit" [ngClass]="!isSubmitEnabled ? 'btn btn-light disabled' : 'orangeBtn'" [disabled]="!isSubmitEnabled" [ngStyle]="{'background-color': primaryColor}">Submit Referral</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (isUrlsDisabled) {
    <div class="container" role="main">
      <div class="row main-home py-0">
        <div class="col-md-12">
          <h1 role="heading" aria-level="1">Please verify the URL that you are attempting to access.</h1>
        </div>
      </div>
    </div>
  }